/*-----------------------------------------------------------------------------
|> ChannelAiring Component
|------------------------------------------------------------------------------
|
| Render a single airing in a channel
|
-----------------------------------------------------------------------------*/
<template>
    <div
        class="vw-channel-airing airing"
        :class="isCurrent ? 'live-airing' : ''"
        :style="{ minWidth: `${width}px!important`, marginLeft: `-${leftMargin}px!important` }"
    >
        <img
            v-if="showImage"
            class="airing-image"
            :src="showImage"
            :alt="`${airing.program.title}`"
        >

        <div v-if="isAds" class="airing-content" :style="{ backgroundColor: bgColor }">
            <p class="airing-title">
                <span>
                    {{ airing.program.title }}
                </span>
            </p>

            <span v-if="isCurrent" class="airing-start-time airing-meta">
                Ad
            </span>

            <span v-else class="airing-start-time airing-meta">
                {{ airing.program.shortDesc }}
            </span>
        </div>

        <div v-else class="airing-content">
            <p class="airing-title">
                <span v-if="airing.program.episodeTitle">
                    {{ airing.program.episodeTitle }}
                </span>
                <span v-else>
                    {{ airing.program.title }}
                </span>
            </p>

            <span v-if="isCurrent" class="airing-start-time airing-meta">
                {{ timeLeft }} Mins Left
            </span>

            <span v-else class="airing-start-time airing-meta">
                {{ datetime(airing.startTime).format('hh:mm A') }}
                -
                {{ datetime(airing.endTime).format('hh:mm A') }}
            </span>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
    props: {
        airing: { type: Object, required: true },
        isCurrent: { type: Boolean, default: false },
    },
    data() {
        return {
            leftMargin: 0,
        }
    },
    computed: {
        hasStarted() {
            return dayjs(this.airing.startTime).isBefore(this.$root.currentTime);
        },
        duration() {
            return dayjs(this.airing.endTime).diff(this.airing.startTime, 'minutes');
        },
        timeLeft() {
            /* If show has already started, add the number minutes untill the
             show ends, plus number of minutes passed for the current hour
            */
            if (this.hasStarted) {
                const minutesTillEnd = dayjs(this.airing.endTime)
                    .diff(this.$root.currentTime, 'minutes');

                return minutesTillEnd + this.$root.currentTime.get('minutes') + 1;

            } else {
                return this.duration;
            }
        },
        image() {
            return this.airing.program.preferredImage.url;
        },
        pixelPerMinute() {
            return 10;
            // const timebarItemWidth = (window.visualViewport.width - this.$root.channelColumnWidth) / this.$root.timebarItemCount;

            // return timebarItemWidth / this.$root.timebarItemLength;
        },
        showImage() {
            return this.airing.program.preferredImage.url || false;
        },
        isAds() {
            return this.airing.isAds || false;
        },
        bgColor() {
            return this.airing.bgColor || '';
        },
        /**
         * Returns the horizontal pixel dimension(width) for the current show
         *
         * The width is calculated by mutiplying the remaining minutes(duration) for
         * the show to end, times the width(in pixel) equivalent of a single minutes for
         * a given guide resolution.
         */
        width() {
            if (this.isCurrent) return 'auto';
            // if (this.hasStarted) {
            //     return 200;
            // } else {
            return this.timeLeft * this.pixelPerMinute;
            // return this.duration * this.pixelPerMinute;
            // }
        }
    },
    mounted() {
        this.setLeftMargin();
    },
    methods: {
        datetime: dayjs,
        /**
         * Left margin value to apply to the first show if the show's `startTime` is
         * behind current hour.
         *
         * It's' equal the # of minutes since the show started, times `pixelPerMinute`.
         */
        setLeftMargin() {
            // this.leftMargin = (this.$root.currentTime.diff(this.airing.startTime, 'minutes')) * this.pixelPerMinute;
        },
    },
}
</script>
